<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Парент</label>
                        <v-select v-model="data.parent" label="name"
                                  :options="parents"
                                  :filterable="false"
                                  @search="onParentSearch"
                                  @search:focus="onParentFocus"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>Код <span class="red">*</span></label>
                        <input type="text"
                               class="form-control"
                               v-model="data.code"
                               :class="{invalid : $v.data.code.$error}"
                        />
                    </div>
                    <div class="form-group">
                        <label>Текст <span class="red">*</span></label>
                        <input type="text"
                               class="form-control"
                               v-model="data.name"
                               :class="{invalid : $v.data.name.$error}"
                        />
                    </div>
                    <div class="form-group">
                        <label>Текст(ru) <span class="red">*</span></label>
                        <input type="text"
                               class="form-control"
                               v-model="data.nameRu"
                               :class="{invalid : $v.data.nameRu.$error}"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {clone} from '@/shared/utils';
    import { required } from 'vuelidate/lib/validators'

    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filter: initFilterModel(),
                data: this.initEmptyData(),
                parents: []
            }
        },
        validations() {
            return {
                data: {
                    code: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    nameRu: {
                        required: required
                    }
                }
            }
        },
        methods: {
            initEmptyData() {
                return {
                    code: '',
                    name: '',
                    nameRu: '',
                    parent: null
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                const vm = this;
                this.$http.post('real-estate/employment/coefficient/field',this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('employmentCoefficientFieldChange', response);
                        }
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            cancel() {
                this.show = false;
            },
            onParentSearch(searchTxt, loading) {
                loading(true);
                this.parents = [];
                this.filter.search = searchTxt;
                this.$http.post('real-estate/employment/coefficient/field/list',this.filter)
                    .then(res => {
                        this.parents = res.data.data;
                        loading(false)
                    }, err => {
                        console.log(err)
                    });
            },
            onParentFocus() {
                this.parents = [];
                this.filter.search = '';
                this.$http.post('real-estate/employment/coefficient/field/list',this.filter)
                    .then(res => {
                        this.parents = res.data.data;
                    }, err => {
                        console.log(err)
                    });
            }
        },
        created() {
            this.filter.parentOnly = true;
            this.filter.page.size = 1000;
            this.$eventBus.$on('showEmploymentCoefficientFieldModal', (data) => {
                if (data) {
                    this.data = clone(data);
                } else {
                    this.data = this.initEmptyData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>